<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.card_collections', 2),
                        href: meta.links.index,
                    },
                    {
                        name: card_collection.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <TitleFieldsFormSection v-if="card_collection.description">
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-12">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.description')" for="description" />
                        <p class="mt-1 w-full whitespace-pre-line">
                            {{ card_collection.description }}
                        </p>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>

        <div class="mt-3">
            <Dashboard :uppy="uppy" :plugins="['Webcam']" :props="{ theme: 'light' }" />
        </div>

        <draggable
            tag="div"
            :list="cardCollection.cards"
            group="cards"
            @start="drag = true"
            @end="drag = false"
            handle=".handle"
            @change="reorderCards(cardCollection.cards)"
            item-key="id"
            class="md:grid md:grid-cols-3 lg:grid-cols-6 md:gap-6 mt-5"
        >
            <template #item="{ element: card, index }">
                <div class="flex flex-col p-4 bg-gray-50 mt-3">
                    <div class="mt-1 flex justify-between">
                        <div><CardRarityIndicator :rarity="card.rarity" /></div>
                        <div>#{{ index + 1 }}</div>
                    </div>
                    <ZoomableImage v-if="card.image_path" :src="card.image_path">
                        <img class="h-32 w-32 object-contain" :src="card.image_path" alt="" :title="card.description" />
                        <template #under-image>
                            <AppCard v-if="card.description">
                                <p class="whitespace-pre-line">{{ card.description }}</p>
                            </AppCard>
                        </template>
                    </ZoomableImage>
                    <div class="mt-3 flex justify-between">
                        <div class="truncate">{{ card.name }}</div>
                    </div>
                    <div class="flex flex-wrap justify-between align-center">
                        <div class="inline-block">
                            <IconGripVertical class="handle inline-block h-4 w-4 text-gray-600 cursor-move" />
                        </div>
                        <div>
                            <InertiaSquareLinkButton action="edit" :href="card.links.edit" />
                            <InertiaSquareDeleteButton
                                :href="card.links.delete"
                                :confirm-text="$t('messages.are_you_sure?')"
                                @finished="reload()"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </draggable>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import draggable from 'vuedraggable';
import { Dashboard } from '@uppy/vue';

import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import Spanish from '@uppy/locales/lib/es_ES';
import XHRUpload from '@uppy/xhr-upload';

import Uppy from '@uppy/core';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import CardRarityIndicator from '@/components/CardRarityIndicator.vue';
import { IconGripVertical } from '@tabler/icons-vue';
import ZoomableImage from '@/components/ZoomableImage.vue';
import AppCard from '@/Shared/AppCard.vue';

export default {
    components: {
        AppCard,
        ZoomableImage,
        PanelPage,
        TitleFieldsFormSection,
        FormLabel,
        Dashboard,
        InertiaSquareLinkButton,
        InertiaSquareDeleteButton,
        draggable,
        CardRarityIndicator,
        IconGripVertical,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'card_collection', 'gamificationSet'],
    data() {
        return {
            drag: false,
            cardCollection: this.card_collection,
        };
    },
    mounted() {
        // this.cardCollection = structuredClone(.value);
    },
    computed: {
        uppy: function () {
            const config = {
                autoProceed: false,
                restrictions: {
                    maxFileSize: 20000000,
                    maxNumberOfFiles: 500,
                    allowedFileTypes: ['image/*', '.jpg', '.jpeg', '.png'],
                },
            };
            if (['es', 'ca'].includes(this.getLocale())) {
                config.locale = Spanish;
            }

            return new Uppy(config)
                .use(XHRUpload, {
                    endpoint: this.meta.links.store_card,
                    method: 'POST',
                    formData: true,
                    fieldName: 'image',
                    headers: {
                        'X-CSRF-TOKEN': this.$page.props.csrf_token,
                    },
                })
                .on('complete', (result) => {
                    if (result.failed.length === 0) {
                        this.reload();
                    }
                });
        },
    },
    beforeUnmount() {
        this.uppy.close({ reason: 'unmount' });
    },
    methods: {
        getLocale() {
            return this.$i18n.locale;
        },
        submit() {
            this.form.patch(this.meta.links.update);
        },
        reload() {
            this.$inertia.visit(this.meta.links.show);
        },
        reorderCards(cards) {
            const newOrder = cards.map((s) => s.id);

            this.$inertia.patch(
                this.meta.links.reorder_cards,
                { cards: newOrder },
                {
                    preserveScroll: true,
                },
            );
        },
    },
};
</script>
